import { SegmentedFilter } from "@/components/ui/segmented-filter"

import type { InventoryLabels, InventoryStatusFilter, InventoryViewMode } from "./inventory-types"

interface InventoryFilterBarProps {
  labels: InventoryLabels
  statusFilter: InventoryStatusFilter
  onStatusFilterChange: (value: InventoryStatusFilter) => void
  viewMode: InventoryViewMode
  onViewModeChange: (value: InventoryViewMode) => void
}

export function InventoryFilterBar({
  labels,
  statusFilter,
  onStatusFilterChange,
  viewMode,
  onViewModeChange,
}: InventoryFilterBarProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <SegmentedFilter
        aria-label="Inventory status"
        value={statusFilter}
        onValueChange={onStatusFilterChange}
        options={[
          { value: "all", label: labels.filters.all },
          { value: "low", label: labels.filters.low },
          { value: "out", label: labels.filters.out },
        ]}
      />

      <div className="flex items-center gap-3">
        <span className="label-industrial mr-2 !tracking-widest opacity-60">{labels.view}</span>
        <SegmentedFilter
          aria-label="Inventory view"
          value={viewMode}
          onValueChange={onViewModeChange}
          options={[
            { value: "comfortable", label: labels.views.comfortable },
            { value: "dense", label: labels.views.dense },
          ]}
        />
      </div>
    </div>
  )
}
